<template lang="html">
  <!-- <div class="slider-socios">
    <div class="slide-track">
      <div class="slide-socio" v-for="(item, index) in logos" :key="index">
        <img :src="baseUrlStorage + item.image" height="100" width="125" alt="" />
        <p>- Socios -</p>
      </div>
    </div>
  </div> -->
  <div class="slider-socios">
    <div class="slide-track" :style="{ width: 'calc(200px * 12)' }">
      <div
        class="slide"
        v-for="(item, index) in [...logos, ...logos]"
        :key="index"
      >
        <img
          :src="baseUrlStorage + item.image"
          height="100"
          width="125"
          alt=""
        />
        <p>- Socios -</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["logos"],
  inject: ["baseUrlStorage"],
  data() {
    return {
      images: [
        "https://i.ibb.co/MS0QqVx/Image-Banner-Home01.png",
        "https://i.ibb.co/X5FPHvQ/Image-Banner-Home02.png",
        "https://i.ibb.co/LzS8830/Image-Banner-Home03.png",
        "https://i.ibb.co/10P2Bwb/Image-Banner-Home04.png",
        "https://i.ibb.co/jZWzKh5/Image-Banner-Home05.png",
        "https://i.ibb.co/QdQc1dw/Image-Banner-Home06.png",
        "https://i.ibb.co/MS0QqVx/Image-Banner-Home01.png",
        "https://i.ibb.co/X5FPHvQ/Image-Banner-Home02.png",
        "https://i.ibb.co/LzS8830/Image-Banner-Home03.png",
        "https://i.ibb.co/10P2Bwb/Image-Banner-Home04.png",
        "https://i.ibb.co/jZWzKh5/Image-Banner-Home05.png",
        "https://i.ibb.co/QdQc1dw/Image-Banner-Home06.png",
      ],
    };
  },
  async mounted() {
    const addNewCSS = (css_text) => {
      css_text = encodeURIComponent(css_text);
      const url = `data:text/css,${css_text}`;
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = url;
      document.head.appendChild(link);
    };
    await this.$nextTick();
    console.log("this.logos");
    console.log(this.logos);
    console.log("this.logos");
    const css_data = `
			@-webkit-keyframes scroll {
				0% {
					transform: translateX(0);
				}
				100% {
					transform: translateX(calc(-200px * ${this.logos.length}));
				}
			}

			@keyframes scroll {
				0% {
					transform: translateX(0);
				}
				100% {
					transform: translateX(calc(-200px * ${this.logos.length}));
				}
			}
			`;

    addNewCSS(css_data);
  },
  created: () => {
    // const duration = 1;
    // const colour = ["#2196F3", "#E91E63"];
  },
};
import "../../scss/loopinfinite.css";
</script>
<style lang="css"></style>
